import { render, staticRenderFns } from "./commonPopups.vue?vue&type=template&id=81532548&scoped=true"
import script from "./commonPopups.vue?vue&type=script&lang=js"
export * from "./commonPopups.vue?vue&type=script&lang=js"
import style0 from "./commonPopups.vue?vue&type=style&index=0&id=81532548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81532548",
  null
  
)

export default component.exports